import { compact, flatMap, go, map, uniqueBy } from 'fxjs/es';
import { getMapleLabsDesignHash } from './designHash/hash.ts';
import { VectorEditorConstantS } from '../../../VectorEditor/S/Constant/module/VectorEditorConstantS.js';
import { USER_CUSTOM_PROPERTY_MAPPING_PATH } from '../../../Maker/S/constant.js';
import { getCharacterReplacedValue } from './replaceDesignItems.js';

export const makeProductFaceHash = (product_face2, base_product_color_id, character, maker_type) => {
  let ness_custom_user_path_values = null;
  if (maker_type === VectorEditorConstantS.KEYRING_EDITOR) {
    ness_custom_user_path_values = [
      {
        id: '5',
        value: '_maple_image_url_with_motion',
      },
      {
        id: '2',
        value: 'gc_name',
      },
    ];
  } else if (maker_type === VectorEditorConstantS.ACRYLIC_FIGURE_EDITOR) {
    ness_custom_user_path_values = [
      {
        id: '5',
        value: '_maple_image_url_with_motion',
      },
    ];
  } else {
    ness_custom_user_path_values = go(
      product_face2.value,
      flatMap((pf) => {
        return go(
          pf.designs,
          map((cv_design) => {
            const user_custom_property_mapping_path =
              cv_design._data[USER_CUSTOM_PROPERTY_MAPPING_PATH] ||
              cv_design._data.cv_image_attrs?._data?.[USER_CUSTOM_PROPERTY_MAPPING_PATH] ||
              cv_design._data.cv_text_image_attrs?._data?.[USER_CUSTOM_PROPERTY_MAPPING_PATH];
            if (!user_custom_property_mapping_path?.id) return;

            return user_custom_property_mapping_path;
          }),
          compact,
        );
      }),
      uniqueBy((user_custom_property_mapping_path) => user_custom_property_mapping_path.value),
    );
  }

  return go(
    ness_custom_user_path_values,
    map((user_custom_property_mapping_path) => {
      const value = getCharacterReplacedValue({ user_custom_property_mapping_path, character });
      return [user_custom_property_mapping_path.id, value?.url || value];
    }),
    (data) => {
      return getMapleLabsDesignHash(data.concat([[1000, base_product_color_id + '']]));
    },
  );
};
